var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 155,
    viewBox: "0 0 200 155",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5002880D-50D8-485D-9F77-19299CC59F6F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.5 5a5.004 5.004 0 0 0-1.464-3.536A5.004 5.004 0 0 0 182.5 0h-165a5.004 5.004 0 0 0-3.536 1.464A5.004 5.004 0 0 0 12.5 5v107.5h175V5z",
    fill: "#D9A426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.967 6.974a3 3 0 0 0-3-3H20.033a3 3 0 0 0-3 3v98.552a3 3 0 0 0 3 3h159.934a3 3 0 0 0 3-3V6.974z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.016 20.75h51v6.984h-51zM27.016 33.553h22.967v6.984H27.016zM27.016 46.357h91.967v6.984H27.016zM27.016 59.16h57.967v6.984H27.016zM27.016 71.963h34.967v6.984H27.016zM27.016 84.766h91.967v6.984H27.016zM83.016 20.75h29.958v6.984H83.016zM55.016 33.553h29.958v6.984H55.016zM117.974 20.75h55.009v6.984h-55.009zM89.974 33.553h83.009v6.984H89.974zM123.984 46.357h49v6.984h-49zM89.984 59.16h83v6.984h-83zM66.984 71.963h106v6.984h-106zM123.984 84.766h49v6.984h-49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CC9543",
    d: "M0 150l12.5-37.5h175L200 150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 150H0v1.396a3 3 0 0 0 3 3h194a3 3 0 0 0 3-3V150z",
    fill: "#A6824A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.e10dcf1610918ea8a343c2aa356dd77b.svg";
export { ForwardRef as ReactComponent };